import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../../store/config';
import { DeliveryDataItem } from '../dataTools/dataTools.types';
import { Refusal, RefusalsBatch, RefusalsFilterSettings, UpdateDeliveryPayload } from './refusals.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/refusals');

export const getRefusalsBatches = actionCreator.async<RefusalsFilterSettings, RefusalsBatch[]>('GET_REFUSALS_BATCHES');
export const updateRefusalsDelivery = actionCreator.async<UpdateDeliveryPayload, DeliveryDataItem>(
  'UPDATE_REFUSALS_DELIVERY',
);
export const getRefusals = actionCreator.async<RefusalsFilterSettings, Refusal[]>('GET_REFUSALS');
export const getRefusalsFilterData = actionCreator.async('GET_REFUSALS_FILTER_DATA');
export const getRefusalsPreset = actionCreator.async('GET_REFUSALS_PRESET');
export const setChangedRefusalIds = actionCreator<string[]>('SET_CHANGED_REFUSAL_IDS');
